export default __webpack_public_path__ + "static/media/berlin-green.25693e54.webp";